import { Controller } from "@hotwired/stimulus"
import { EditorView, basicSetup } from "codemirror"
import { html } from "@codemirror/lang-html"
import { oneDark } from "@codemirror/theme-one-dark"
import { EditorState } from "@codemirror/state"

export default class extends Controller {
  static targets = ["editor", "textarea"]
  static values = { minHeight: { type: String, default: "400px" } }

  connect() {
    const isDark = document.documentElement.classList.contains("dark")
    const content = this.textareaTarget.value || ""

    const extensions = [
      basicSetup,
      html(),
      EditorView.updateListener.of((update) => {
        if (update.docChanged) {
          this.textareaTarget.value = update.state.doc.toString()
          // Dispatch a bubbling `input` event so parent Stimulus controllers
          // (e.g. email-template-preview's sourceChanged action) react to live
          // edits. Backwards-compatible — pre-existing consumers don't bind
          // to input events on the wrapper.
          this.textareaTarget.dispatchEvent(new Event("input", { bubbles: true }))
        }
      }),
      EditorView.theme({
        "&": { minHeight: this.minHeightValue },
        ".cm-scroller": { overflow: "auto" },
        ".cm-content": { minHeight: this.minHeightValue }
      })
    ]

    if (isDark) extensions.push(oneDark)

    this.view = new EditorView({
      state: EditorState.create({ doc: content, extensions }),
      parent: this.editorTarget
    })

    this.textareaTarget.style.display = "none"
  }

  disconnect() {
    if (this.view) {
      this.view.destroy()
      this.view = null
    }
    this.textareaTarget.style.display = ""
  }
}
